import { dispatchCustomEvent } from "@/shared/utils/dom";

export const EVENT_CUSTOM_IS_LAST_POINTER_MOUSE = "isLastInputWasMouse";
export const WINDOW_KEY_IS_LAST_POINTER_MOUSE = "isLastInputWasMouse";

export const dispatchCustomEventLastInputWasMouseChange = (isLastInputWasMouse) => {
  dispatchCustomEvent(EVENT_CUSTOM_IS_LAST_POINTER_MOUSE, isLastInputWasMouse);
};
